import AuthenticationApi from "./api/AuthenticationApi";
import AuthenticationStore from "./stores/AuthenticationStore";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Footer from "./components/Footer";
import getTranslationsForLang from "./lib/getTranslationsForLang";
import queryString from "query-string";
import { I18n } from "react-polyglot";
import Loadable from "react-loadable";
import Nav from "./components/Nav";
import PrivateRoute from "./components/PrivateRoute";
import React, { Component } from "react";
import translations from "./lib/translations.json";

const Loading = () => null;

const EntryTicketCheckin = Loadable({
  loader: () => import("./components/EntryTicketCheckin"),
  loading: Loading
});

const EventCheckin = Loadable({
  loader: () => import("./components/EventCheckin"),
  loading: Loading
});

const Events = Loadable({
  loader: () => import("./components/Events"),
  loading: Loading
});

const Settings = Loadable({
  loader: () => import("./components/Settings"),
  loading: Loading
});

const Login = Loadable({
  loader: () => import("./components/Login"),
  loading: Loading
});

function getLanguage() {
  return (
    AuthenticationApi.getLang() ||
    window.navigator.userLanguage ||
    window.navigator.language ||
    "en"
  ).split("-")[0];
}

class App extends Component {
  state = {
    lang: getLanguage()
  };

  componentWillMount() {
    const query = queryString.parse(window.location.search);

    if (query.token) {
      AuthenticationApi.setToken(query.token);
    }

    if (query.lang) {
      AuthenticationApi.setLang(query.lang);
      this.setState({
        lang: query.lang
      });
    }
  }

  componentDidMount() {
    AuthenticationStore.addChangeListener(this.onChange);
  }

  componentWillUnmount() {
    AuthenticationStore.removeChangeListener(this.onChange);
  }

  onChange = () => {
    const newLang = AuthenticationStore.getLang();
    if (newLang) {
      this.setState({ lang: newLang });
    }
  };

  render() {
    const { lang } = this.state;

    return (
      <I18n locale={lang} messages={getTranslationsForLang(translations, lang)}>
        <Router>
          <div>
            <Nav />
            <PrivateRoute exact path="/" component={Events} />
            <PrivateRoute exact path="/events" component={Events} />
            <PrivateRoute
              exact
              path="/events/:id/checkin"
              component={EventCheckin}
            />
            <PrivateRoute
              exact
              path="/tickets"
              component={EntryTicketCheckin}
            />
            <PrivateRoute exact path="/settings" component={Settings} />
            <Route path="/login" component={Login} />
            <Footer />
          </div>
        </Router>
      </I18n>
    );
  }
}

export default App;
